import { atom } from 'jotai';

import { brokeredLoadFileConfirmUploadAtom } from '../_graphql/mutationBrokeredLoadFileConfirmUpload';
import { brokeredLoadFileCreateAtom } from '../_graphql/mutationBrokeredLoadFileCreate';
import { brokeredLoadFileDeleteAtom } from '../_graphql/mutationBrokeredLoadFileDelete';
import { brokeredLoadDetailQueryAtom } from '../_graphql/queryBrokeredLoadDetail';
import { brokeredLoadSalesOrderLineItemsQueryAtom } from '../_graphql/querySalesOrderLineItems';
import { brokerageRoutePaths } from '../routes';
import {
  BrokeredLoadDetailsTab,
  BrokeredLoadFormState,
  BrokeredLoadRecord,
} from '../types/brokeredLoad';

import { atomFromQueryString, atomFromRoutePath } from '~/shared/state';

// 🟣🟣🟣 PARAMS
export const $brokeredLoadPathParams = atomFromRoutePath(
  brokerageRoutePaths.loadDetail,
);
export const $brokeredLoadId = atom((get) =>
  get($brokeredLoadPathParams)?.id
    ? String(get($brokeredLoadPathParams)?.id)
    : undefined,
);
export const $selectedTab =
  atomFromQueryString.string<BrokeredLoadDetailsTab>('tab');

// 🔘🔘🔘 PLAIN ATOMS
export const $isEditMode = atom<boolean>(false);
export const $isShippedDialogOpen = atom<boolean>(false);
export const $isReceivedDialogOpen = atom<boolean>(false);
export const $isVoidDialogOpen = atom<boolean>(false);

// 🟣🟣🟣 URL QUERY STRING ATOMS
export const $materialsPhase = atomFromQueryString.string<
  'Requested' | 'Shipped'
>('materialsPhase');

// 🟢🟢🟢 REMOTE DATA -> brokered load detail
export const $remoteBrokeredLoadDetail = brokeredLoadDetailQueryAtom((get) => ({
  variables: {
    loadId: get($brokeredLoadId) ?? '',
  },
  skip: !get($brokeredLoadId),
}));

// 🟢🟢🟢 COMPUTED DATA -> mapped brokered load record
export const $brokeredLoadRecord = atom<BrokeredLoadRecord | null>((get) => {
  const query = get($remoteBrokeredLoadDetail);
  return query.data ?? null;
});

// 🔘🔘🔘 FORM STATE
export const $brokeredLoadForm = atom<BrokeredLoadFormState>({
  lineItems: [],
});

export const $hasUnsavedChanges = atom<boolean>(false);

// 🟢🟢🟢 REMOTE DATA -> sales order line items for load
export const $salesOrderLineItems = brokeredLoadSalesOrderLineItemsQueryAtom(
  (get) => ({
    variables: {
      salesOrderId: get($brokeredLoadForm).salesOrderId ?? '',
    },
    skip: !get($brokeredLoadForm).salesOrderId,
  }),
);

// 🟠🟠🟠 FILE MUTATIONS
export const $createBrokeredLoadFile = brokeredLoadFileCreateAtom({
  onSuccess: (get) => {
    get($remoteBrokeredLoadDetail).refetch?.();
  },
});

export const $confirmBrokeredLoadFileUpload = brokeredLoadFileConfirmUploadAtom(
  {},
);

export const $deleteBrokeredLoadFile = brokeredLoadFileDeleteAtom({
  onSuccess: (get) => {
    get($remoteBrokeredLoadDetail).refetch?.();
  },
});
